import { ExcellentQuality } from './ExcellentQuality/ExcellentQuality';
import { PoorQuality } from './PoorQuality/PoorQuality';
import { getQualityScore } from './getQualityScore/getQualityScore';
import { useAppStateContext } from '../../AppStateProvider/AppStateProvider';
import { QualityModal } from './QualityModal/QualityModal';
import { useCallback, useState } from 'react';
import { PrimaryButton } from '../../common/PrimaryButton';
import { Line } from 'react-chartjs-2';

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { useEmptySpeedTest, useSpeedTestOnDemand } from '../../AppStateProvider/useSpeedTest/useSpeedTest';
import { Grid, Typography } from '@material-ui/core';
import { useAddHistoryResult } from '../Results/HistoryResults/useAddHistoryResult';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

export enum QualityScore {
  Poor,
  Suboptimal,
  Good,
  Excellent,
}

var counter: number = 0;
export function Quality() {
  const { state, dispatch, userAgentInfo } = useAppStateContext();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const labels: number[] = [];
  let downloadSpeedResults: [{}] = [{ x: 1, y: 0 }];
  state.downloadSpeed.forEach(function (value) {
    if (value.speed !== undefined) downloadSpeedResults.push({ x: value.time, y: value.speed });
    addAndSort(labels, value.time!);
  });

  let uploadSpeedResults: [{}] = [{ x: 1, y: 0 }];
  state.uploadSpeed.forEach(function (value) {
    if (value.speed !== undefined) uploadSpeedResults.push({ x: value.time, y: value.speed });
    addAndSort(labels, value.time!);
  });

  function addAndSort(arr: number[], val: number) {
    if (!arr.some((e) => e === val)) {
      arr.push(val);
      var i = arr.length - 1;
      var item = arr[i];
      while (i > 0 && item < arr[i - 1]) {
        arr[i] = arr[i - 1];
        i -= 1;
      }
      arr[i] = item;
    }
    return arr;
  }

  const options = {
    responsive: true,
    plugins: {
      tooltip: {
        callbacks: {
          title: function (context: any) {
            let label = context[0].label || '';
            if (label !== '') {
              var currTime: any = new Date(Number(label));
              return currTime.toLocaleTimeString();
            }
          },
        },
      },
      legend: {
        display: false,
      },
      title: {
        display: false,
      },
    },
    scales: {
      xAxis: {
        display: true,
        title: {
          display: true,
          text: 'time',
        },
        ticks: {
          callback: function (index: any) {
            if (labels[index] !== undefined) var currTime: any = new Date(labels[index]);
            return currTime.toLocaleTimeString();
          },
        },
      },
      yAxis: {
        display: true,
        title: {
          display: true,
          text: 'mbps',
        },
      },
    },
    fill: true,
  };

  let data = {
    labels,
    datasets: [
      {
        label: 'Download',
        display: false,
        data: downloadSpeedResults,
        borderColor: 'rgb(255, 99, 132)',
        backgroundColor: 'rgba(255, 99, 132, 0.5)',
      },
      {
        label: 'Upload',
        data: uploadSpeedResults,
        borderColor: 'rgb(99,143,255)',
        backgroundColor: 'rgba(99,112,255,0.5)',
      },
    ],
  };
  const [started, setStarted] = useState(false);
  var startSpeedTestOnDemand = useSpeedTestOnDemand(dispatch, true);
  var stopSpeedTestOnDemand = useSpeedTestOnDemand(dispatch, false);
  var cleanSpeedTest = useEmptySpeedTest(dispatch);
  const startSpeedTestOnDemandConst = useCallback(async () => {
    (await cleanSpeedTest)();
    (await startSpeedTestOnDemand)();
    setStarted(true);
  }, [cleanSpeedTest, startSpeedTestOnDemand]);

  const stopSpeedTest = useCallback(async () => {
    (await stopSpeedTestOnDemand)();
  }, [stopSpeedTestOnDemand]);

  const speedTestFinished: boolean =
    state.downloadSpeedResult != null && state.uploadSpeedResult != null && state.bitrateTestUDP.reportUDP !== null;

  const addHistoryResult = useAddHistoryResult(state, userAgentInfo);

  const runAddHistoryResult = useCallback(async () => {
    await addHistoryResult();
  }, [addHistoryResult]);

  if (speedTestFinished && counter < 1 && localStorage.getItem('token') !== 'undefined') {
    runAddHistoryResult();
    counter++;
  }
  const { bitrateUDP, bitrateTCP, totalQualityScore } = getQualityScore(
    state.bitrateTestUDP.reportUDP,
    state.bitrateTestTCP.reportTCP
  );

  return (
    <>
      <QualityModal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        bitrateUDP={bitrateUDP}
        bitrateTCP={bitrateTCP}
        isTCPEnabled={state.bitrateTestTCP.enabled}
        downloadSpeed={state.downloadSpeedResult}
        uploadSpeed={state.uploadSpeedResult}
        rttResult={state.rttResult}
        jitterResult={state.jitterResult}
      />
      <Typography variant="h1" gutterBottom>
        Speed Test
      </Typography>
      <Grid style={{ display: 'flex', alignItems: 'center' }}>
        <PrimaryButton onClick={startSpeedTestOnDemandConst} disabled={!speedTestFinished}>
          Start
        </PrimaryButton>
        <PrimaryButton onClick={stopSpeedTest} disabled={!started}>
          Stop
        </PrimaryButton>
        <Typography variant="body1">
          <strong>Jitter {state.jitterResult} ms |</strong>
          <strong> RTT {state.rttResult} ms</strong>
        </Typography>
      </Grid>
      <Line options={options} data={data} height={'70%'} />
      {speedTestFinished &&
      (totalQualityScore === QualityScore.Good || totalQualityScore === QualityScore.Excellent) ? (
        <ExcellentQuality quality={totalQualityScore} openModal={() => setIsModalOpen(true)} />
      ) : speedTestFinished ? (
        <PoorQuality quality={totalQualityScore} openModal={() => setIsModalOpen(true)} />
      ) : null}
    </>
  );
}
